module.exports = __webpack_public_path__ + "img/icon-mention.a3c92ead.svg";